import { useCallback } from "react";

import __ from "web/Layout/Translations";

import Button from "web/Components/Common/ButtonCC";
import CodeModal from "web/Components/Common/CodeItem/CodeModal";
import modalOverrides from "web/Components/Common/CodeItem/CodeModal/codeModalModalOverrides.scss";

import { ModalActionTypes } from "web/hooks/useModal/useModalTypes";

import { ProductCodeFrontendStatus } from "web/types/Code";

import { useAppContext } from "web/context/app";

import classes from "./showCode.scss";

interface IShowCodeProps {
  name?: string;
  isCanceled?: boolean;
  itemId: number;
  orderStatusCode?: string;
  sku: string;
  isShowCodeDisabled: boolean;
  product_expiration_date?: string;
  userUsedDate?: string;
  userUsed?: boolean | number;
  productCodeFrontendStatus?: ProductCodeFrontendStatus;
  onAvailabilityChange?: (isAvailable: boolean) => void;
}

const ShowCode = ({
  name = "",
  isCanceled = false,
  itemId,
  orderStatusCode,
  sku = "",
  isShowCodeDisabled,
  product_expiration_date = "",
  userUsedDate = "",
  userUsed = false,
  productCodeFrontendStatus = "" as ProductCodeFrontendStatus,
  onAvailabilityChange,
}: IShowCodeProps) => {
  const orderPaid =
    productCodeFrontendStatus === ProductCodeFrontendStatus.PAID ||
    productCodeFrontendStatus === ProductCodeFrontendStatus.USED ||
    productCodeFrontendStatus === ProductCodeFrontendStatus.EXPIRED;

  const { modal } = useAppContext();
  const { dispatch } = modal;

  const showModal = useCallback(() => {
    dispatch({
      type: ModalActionTypes.ADD_MODAL,
      modal: isCanceled ? null : (
        <CodeModal
          productName={name}
          itemId={itemId}
          orderPaid={orderPaid}
          sku={sku}
          product_expiration_date={product_expiration_date}
          userUsedDate={userUsedDate}
          userUsed={userUsed}
          productCodeFrontendStatus={productCodeFrontendStatus}
          onAvailabilityChange={onAvailabilityChange}
        />
      ),
      ariaLabel: __("Twój kod"),
      hideCloseButton: true,
      classes: { content: modalOverrides.content },
    });
  }, [
    dispatch,
    name,
    itemId,
    orderPaid,
    sku,
    product_expiration_date,
    userUsedDate,
    isCanceled,
    userUsed,
    productCodeFrontendStatus,
    orderStatusCode,
    onAvailabilityChange,
  ]);

  return (
    <div className={classes.root}>
      <Button
        onClick={showModal}
        className={classes.button}
        dataT1="show_code_button"
        disabled={isShowCodeDisabled}
        ariaLabel={`${__("Wyświetl kod")} - ${__("Produkt")} ${name} `}
      >
        <span className={classes.label} data-t1="show_code_label">
          {__("Wyświetl kod")}
        </span>
      </Button>
    </div>
  );
};

export default ShowCode;
